module.exports = __webpack_public_path__ + "img/branch_image3.fd045c0d.jpg";